import React from "react";
import arrow from "../assets/arrow-circle-right-solid.svg";
import styled from "styled-components";

const SubmitWrapper = styled.div`
  position: relative;

  .submit-btn {
    color: white;
    font-size: 0.8rem;
    background-color: #ff363f;
    padding: 0.6rem 0.6rem;
    border-radius: 30px;
    width: 10rem;
    border: none;
    text-align: left;
    cursor: pointer;

    &:disabled {
      background-color: grey;
      margin-bottom: 1rem;
    }
  }
  img {
    position: absolute;
    top: 7px;
    left: 130px;
    content: "";
    width: 20px;
  }
`;
const StyledBackButton = styled.button`
  text-align: center;
  color: white;
  margin-top: 5rem;
  background-color: #ff363f;
  padding: 1rem;
  border-radius: 30px;
  border: none;
  font-size: 0.8rem;
`;

export const FormButton = ({ value, disabled }) => {
  return (
    <SubmitWrapper>
      <input
        disabled={disabled}
        className="submit-btn"
        type="submit"
        value={value}
      />
      <img src={arrow} alt="right arrow" />
    </SubmitWrapper>
  );
};

export const Button = ({ value, func, disabled }) => {
  return (
    <SubmitWrapper>
      <button
        disabled={disabled}
        onClick={() => {
          func();
        }}
        className="submit-btn"
      >
        {value}
      </button>
      <img src={arrow} alt="right arrow" />
    </SubmitWrapper>
  );
};

export const BackButton = () => {
  return <StyledBackButton>Go back</StyledBackButton>;
};
